function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask-top-rays-0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 375,
  height: 100
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0.0679186L375 0L374.973 78.202C363.596 87.8743 344.518 91.9554 317.739 90.4451C277.57 88.1797 207.046 67.7855 127.471 67.7855C74.4207 67.7855 31.9305 78.5237 0 100V0.0679186Z",
  fill: "white"
}));

var SvgTopRays = function SvgTopRays(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-top-rays-0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.786 144.87L375 105.234V80.1497L188.183 144.908L188.786 144.87Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.925 144.924L375 47.633V16.3906L187.809 144.933L187.925 144.924Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.725 144.941L375 -27.7934V-49.8708H353.776L187.675 144.941H187.725Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.625 144.945L311.291 -49.8708H281.261L187.592 144.945H187.625Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.562 144.949L250.001 -49.8708H225.875L187.537 144.949H187.562Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.512 144.958L187.5 144.954L187.512 144.949L198.751 -49.8708H176.253L187.5 145.145L187.512 144.958Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.129 -49.8708H125.003L187.5 145.145L149.129 -49.8708Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.748 -49.8708H63.709L187.5 145.145L93.748 -49.8708Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2238 -49.8708H0V-27.7976L187.5 145.145L21.2238 -49.8708Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.3906V47.633L187.5 145.145L0 16.3906Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80.1453V105.233L187.5 145.145L0 80.1453Z",
    style: {
      fill: "var(--color-primary)"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopRays, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/top-rays.f70543df.svg";
export { ForwardRef as ReactComponent };